import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedLine = () => {
  return { segments: [], selectedStationList: [] };
};

export default {
  state: () => ({
    selectedLine: getDefaultSelectedLine(),
    lines: [],
    publishedLines: [],
  }),

  mutations: {
    setSelectedStationList(state, stationList) {
      Vue.set(state, "selectedStationList", stationList);
    },
    setSelectedLine(state, line) {
      Vue.set(state, "selectedLine", line);
    },
    setLines(state, lines) {
      Vue.set(state, "lines", lines);
    },
    setPublishedLines(state, lines) {
      Vue.set(state, "publishedLines", lines);
    },
    setDefaultSelectedLine(state) {
      Vue.set(state, "selectedLine", getDefaultSelectedLine());
    },
    setDefaultLineModule(state) {
      Vue.set(state, "selectedLine", getDefaultSelectedLine());
      Vue.set(state, "lines", []);
      Vue.set(state, "publishedLines", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createLine: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/lines/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadLines: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/lines/entity").then((response) => {
        // context.commit("setLines", response.data);
        return response.data;
      });
    },

    loadLine: (context, request) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/lines/entity/" + request.id).then((response) => {
        context.commit("setSelectedLine", response.data);
        return response.data;
      });
    },

    loadPublishedLines: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/lines/entity/published").then((response) => {
        context.commit("setPublishedLines", response.data);
        return response.data;
      });
    },

    loadLineHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/inventory/lines/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },

    loadSelectedLineHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/lines/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteLine: (context, line) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/lines/entity/" + line.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          line.intents = intents;
          line.intentId = response.data.id;
          return line;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftLine: (context, line) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/lines/draft/" + line.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishLine: (context, line) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/lines/publish/" + line.intentId)
        .then((response) => {
          if (response.data) {
            response.data.intentId = 0;
          }
          return response.data;
        })
        .catch((error) => {
          return "error";
        });
    },

    sendToApprovalLines: (context, line) => {
      return axios.get(context.getters.getMcServiceUrl + "/lines/sendToApproval/" + line.intentId).then((response) => {
        if (line.intents[0].type === "CREATE_LINE") {
          line.intents[0].status = "WAITING_APPROVAL";
        } else if (line.intents[0].type === "UPDATE_LINE") {
          line.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    rejectLine: (context, line) => {
      return axios.get(context.getters.getMcServiceUrl + "/lines/reject/" + line.intentId).then((response) => {
        if (line.intents[0].type === "DELETE_LINE") {
          line.intents = null;
          line.intentId = 0;
        } else if (line.intents[0].type === "CREATE_LINE") {
          line.intents[0].status = "DRAFT";
        } else if (line.intents[0].type === "UPDATE_LINE") {
          line.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    recallLine: (context, line) => {
      return axios.get(context.getters.getMcServiceUrl + "/lines/recall/" + line.intentId).then((response) => {
        helper.recallOrRejectEntity(line, "line");
        return response.data;
      });
    },

    cancelLine: (context, line) => {
      return axios.get(context.getters.getMcServiceUrl + "/lines/cancel/" + line.intentId).then((response) => {
        return response.data;
      });
    },

    matchOrer: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/lines/match-orer", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getSelectedStationList: (state) => {
      return state.selectedStationList;
    },
    getSelectedLine: (state) => {
      return state.selectedLine;
    },

    getLines: (state) => {
      return state.lines;
    },

    getPublishedLines: (state) => {
      return state.publishedLines;
    },
    getLinesMap: (state) => {
      if (state.publishedLines.length <= 0) return;
      return state.publishedLines.reduce(function (map, line) {
        map[line.id] = line;
        return map;
      }, {});
    },
  },
};
